import { WHATSAPP_NUMBER } from "../shared/links.js";

export function demoWhatsappHref(brandName: string | null): string {
  const text = brandName
    ? `Oi! Sou da ${brandName} e testei a demonstração da Kuori.`
    : "Oi! Sou cerimonialista e testei a demonstração da Kuori.";
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export function demoQuoteHref(brandName: string | null): string {
  const text = brandName
    ? `Oi! Sou da ${brandName}, testei a demonstração e quero fazer um orçamento.`
    : "Oi! Testei a demonstração e quero fazer um orçamento.";
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}
